import { BUSINESS, SITE_URL } from "../data/businessInfo";
import { translations } from "../translations/translations";

function toAbsoluteUrl(pathOrUrl) {
  if (!pathOrUrl) return undefined;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return `${SITE_URL}${pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`}`;
}

function getBusinessDescription(language) {
  return language === "pt" ? BUSINESS.descriptionPt : BUSINESS.description;
}

export function buildOpenGraphMetadata(
  pathname,
  villa,
  villaImageUrl,
  language = "en",
) {
  const t = translations?.[language] || translations.en;
  const description = getBusinessDescription(language);
  const siteName = BUSINESS.name;
  const locale = language === "pt" ? "pt_PT" : "en_US";
  const alternateLocale = language === "pt" ? "en_US" : "pt_PT";
  const pageUrl = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;

  const base = {
    type: "website",
    siteName,
    locale,
    alternateLocale,
    image: BUSINESS.image,
    imageAlt: siteName,
    twitterCard: "summary_large_image",
  };

  if (pathname.startsWith("/villa/") && villa) {
    return {
      ...base,
      title: `${villa.title} | ${siteName}`,
      description: villa.shortDescription,
      image: toAbsoluteUrl(villaImageUrl) || BUSINESS.image,
      imageAlt: `${villa.title} at ${siteName}`,
      url: `${SITE_URL}/villa/${villa.slug}`,
    };
  }

  if (pathname === "/reservations") {
    return {
      ...base,
      title:
        language === "pt"
          ? `Reservas | ${siteName}`
          : `Reservations | ${siteName}`,
      description:
        language === "pt"
          ? `Pedido de reserva na ${siteName}, ${BUSINESS.descriptionPt}.`
          : `Request a reservation at ${siteName}, ${BUSINESS.description}.`,
      url: `${SITE_URL}/reservations`,
    };
  }

  if (pathname === "/region" || pathname === "/regiao") {
    return {
      ...base,
      title: `${t.region.title} | ${siteName}`,
      description: t.region.lead,
      url: pageUrl,
    };
  }

  return {
    ...base,
    title: `${siteName} — ${description}`,
    description,
    url: pageUrl,
  };
}
